export enum AlarmDeliveryStatus {
  queued = 'queued',
  dialing = 'dialing',
  retry_wait = 'retry_wait',
  acked = 'acked',
  failed = 'failed',
  sent = 'sent',
  canceled = 'canceled',
}
